
import React from 'react';
import { Stack } from 'office-ui-fabric-react/lib/Stack';

import IsknDataSetKatuzeInfo from './IsknDataSetKatuzeInfo';

const IsknDataSetKatuzeInfos = ({
    katuzeInfoData,
    projectKatuzeItems
}) => {

    return (
        <Stack horizontal>
            {katuzeInfoData.map(item => {
                return (
                    <IsknDataSetKatuzeInfo
                        key={item.isknDate}
                        data={item}
                        projectKatuzeItems={projectKatuzeItems}
                    />
                );
            })}
        </Stack>
    );
}

export default IsknDataSetKatuzeInfos;
